import Alpine from 'alpinejs';
import persist from '@alpinejs/persist';

import LeadForm from './components/lead-form';
import BlogPosts from './components/blog-posts';
import ZoomOnScroll from './components/zoom-on-scroll';

window.Alpine = Alpine;

Alpine.plugin(persist);
Alpine.data('leadForm', LeadForm);
Alpine.data('blogPosts', BlogPosts);
Alpine.data('zoomOnScroll', ZoomOnScroll);

Alpine.start();
